import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import { FormattedMessage } from 'react-intl'
import { SocialMedia } from '../components/socialmedia';

const SocialNetworks = () => (
  <Layout>
    <SEO title="Social Networks" keywords={['social', 'network', 'YWHWH is my salvation', 'media']}/>
    
    <h1><FormattedMessage id="social-networks" /></h1>

    <SocialMedia />
  </Layout>
)

export default SocialNetworks
